<template>
  <div id="user-container" class="grid-x align-stretch">
    <div
      class="gird-y align-middle auto"
      :class="{ 'cursor-pointer': isAdminOfOrg }"
      id="topbar-user-name"
      v-if="user.isAuthenticated"
    >
      <div class="cell auto grid-x align-middle user-name">
        <i class="cell bi bi-person-fill user-icon shrink"></i>
        <div class="cell auto">{{ user.user.profile.email }}</div>
      </div>
      <div class="menu" v-if="isAdminOfOrg">
        <ul>
          <li>
            <RouterLink to="/organizations">
              {{ $t('messages.navbar.organization') }}
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>

    <div id="topbar-user-button" class="cell shrink grid-x align-middle" @click="loginButton">
      <i
        class="cell bi user-icon shrink"
        :class="{ 'bi-chevron-left': user.isAuthenticated, 'bi-chevron-right': !user.isAuthenticated }"
      ></i>
      <div class="cell auto">{{ user.isAuthenticated ? 'Logout' : 'Login' }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, ref, watch } from 'vue'
import { authenticationInformation } from '@/oidc/authentication'
import { useOrganizationsStore } from '@/stores'
import { storeToRefs } from 'pinia'

export default defineComponent({
  name: 'TopbarUserComponent',
  setup() {
    const user = authenticationInformation().user
    const orgStore = useOrganizationsStore()
    const { organizations } = storeToRefs(orgStore)

    const featureFlags: { userManagementEnabled: boolean } | undefined = inject('featureFlags')

    const loginButton = () => {
      if (!user?.isAuthenticated) {
        user?.login()
      } else {
        user?.logout()
      }
    }

    const isAdminOfOrg = ref<boolean>(false)

    watch(organizations, async (newOrg) => {
      const orgs = await newOrg
      isAdminOfOrg.value = orgs !== null && orgs?.length > 0
    })

    return {
      user,
      isAdminOfOrg,
      featureFlags,
      loginButton,
    }
  },
})
</script>

<style lang="scss" scoped>
#user-container {
  font-size: 1.3rem;
}

#topbar-user-name {
  position: relative;
  min-width: 10rem;
  border-left: 1px solid $gray;
  padding-left: $default-padding;
  padding-right: $default-padding;
  cursor: default;

  &.cursor-pointer {
    cursor: pointer;
  }

  .user-name {
    height: 100%;
  }

  .cell {
    padding: 0;
    margin: 0;
  }

  .menu {
    box-shadow: 0 5px 8px 0 rgb(0 0 0 / 20%), 0 7px 20px 0 rgb(0 0 0 / 17%);
    display: none;
    position: absolute;
    z-index: 10;
    background-color: $light-gray;
    width: 100%;
    margin-top: -2px;
    margin-left: -0.5rem;

    li a {
      color: $petrol;
    }

    padding: 1rem 0.5rem;

    ul {
      list-style: none;
      padding: o;
      margin: 0;
    }
  }

  &:hover > .menu {
    display: block;
  }
}

#topbar-user-button {
  border-left: 1px solid $gray;
  padding: $default-padding;
  padding-right: $default-padding;
  user-select: none;
  width: 6.5rem;
  cursor: pointer;
}

.user-icon {
  font-size: 1.9rem;
}
</style>
